import { useIntl } from 'gatsby-plugin-intl'

const useLocalize = (): ((key: string) => string) => {
  const intl = useIntl()
  return (key: string) => {
    const result = intl.formatMessage({
      id: key,
    })
    return result !== key ? result : ''
  }
}

export default useLocalize
